import React from 'react'
import './workflow-chip-2023.css'
import { truncate } from '../../Calendar/calendarFunctions'

const WorkflowChip2023 = ({workflow, setOpenWorkflowModal2023, getNotesAboutModal}) => {

    const openUpTheWorkflow = () => {
        getNotesAboutModal(workflow.todoId, 'tasksId', workflow.todoName)
        setOpenWorkflowModal2023(workflow)
    }

    return(
        <div className='workflow-chip-2023' onClick={() => openUpTheWorkflow()}>
            <div className='workflow-chip-2023__name'>{truncate(workflow.todoName, 27)}</div>
            <div className='workflow-chip-2023__school' style={workflow.whichSchool ? {border: '1px solid gray'} : {border: 'none'}}>{workflow.whichSchool && workflow.whichSchool.toUpperCase()}</div>
            {workflow.todoSubtasks.filter(task => !task.subtaskCompleted && task ).length !== 0 && <div className='task-chip-2023__tasks-left'>{(workflow.todoSubtasks.filter(task => !task.subtaskCompleted && task )).length}</div>}
        </div>
    )
}
export default WorkflowChip2023